import { Component, OnInit, Output, EventEmitter, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription} from 'rxjs';
import { LoaderService } from '../../loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { HubConnection } from 'src/app/applicationModules/chat/service/chatHubService.service';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
    selector: 'app-chatpanel',
    templateUrl: './chatpanel.component.html',
    styleUrls: ['./chatpanel.component.scss']
})
export class ChatpanelComponent implements OnInit {

  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  userListResponseHolder: any;

  value = '';

  pageModelData = {
    pageIndex: 0,
    pageSize: 500,
    SearchKey:"",
    databaseID: 0,
    organizationID: 0
  };
  pageIndex: any;
  pageSize: any;
  currentDate:any

  peoples: any[] = [];
  DoneButtonShow:boolean=false;
  groupName:string="";
  selectedUser:any[] = [];
  timeout = null;
  users:any[] = [];
  LoggedInEmail:string="";
  chatId:any;
  searchTerm: any="";
  newChatRecivedSubscription: Subscription;
  newGroupCreatedSubscription: Subscription; 
  userRemovedSubscription: Subscription; 
  clickEventsubscription: Subscription; 
  clickEventsubscriptions: Subscription; 
  newChatSubscription: Subscription; 

  hide:boolean = false;
  open:boolean = true;
  showPanel = false;
  showSearch:boolean = false;

  @Output() hideChat = new EventEmitter<boolean>()
  @Output() openChatWindow = new EventEmitter<boolean>()

  
  roomId:any;
  participantDetails:any=[];
  message:string="";
  sendButtonShow:boolean=false;
  groupname:string="";
  imageUrl:string="";
  messageList:any=[];
  results:any[];

  filepath:any ="";
  fileType :any="";
  fileName:any ="";
  fileToUpload:any;

  @ViewChild('Input') InputFile: ElementRef;
  @ViewChild('scrollBottom') private scrollBottom: ElementRef;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @Output() documentViewer = new EventEmitter<boolean>();
  searchValue: any;
  isEnabled: boolean;
  spinner: boolean;
  OfficeIDList: any=[];
  myOfficeID: any;

    constructor(private dialog: MatDialog,private loaderService: LoaderService,
      private ChatsignalRconnaction:HubConnection,private toastr: ToastrService,
      private statusConst: StatusConstant,private encryptionAlgo: EncryptionService,
      private reusableClass: ReusableClasses,private _dataSharingService: DataSharingService) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      if(encryptedtoken!=null){
        const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
        this.databaseId = sessionStorage.getItem('databaseId')?? '';
         this.organizationId = sessionStorage.getItem('organizationID')?? '';
        this.LoggedInEmail=sessionStorage.getItem('email');
        this.currentUser = jwt_decode(token);  
        
        var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
        offices.forEach(oe => {
         this.OfficeIDList.push(oe.officeID)	
         if(oe.isMyoffice==true)
          this.myOfficeID=oe.officeID;
        });	 
      }
     
    }   
       
    ngAfterViewInit() {
      this.ChatsignalRconnaction.createHubConnection();
      this.newGroupCreatedSubscription = this.ChatsignalRconnaction.newGroupCreated.subscribe(data => {  
      var currentUser=data.filter((itm) => itm.toLowerCase() === ((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
       );
       if(currentUser?.length >0){
          this.GetAllRoomsforUser();
        }
       });
  
       this.userRemovedSubscription = this.ChatsignalRconnaction.userRemoved.subscribe(data => {
        var currentUser=data.userIdLst.filter((itm) => itm.toLowerCase() === ((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
        );
         if(currentUser?.length >0){
          const index = this.users.findIndex((itm) => itm.id === data.groupId);
          if (index >= 0) {
            this.users.splice(index, 1);
          }       
          }
         });
  
       this.newChatRecivedSubscription = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
        if(data!=null){
          if(data.fromUser.email.toLowerCase()!=((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email')).toLowerCase()){
            var room = this.users?.find((itm) => itm.id === data.roomId);
            if(room!=null){
              if(room.unReadMessages!=null){
               let index= this.users.findIndex((itm) => itm.id === data.roomId);
               this.users.unshift(this.users.splice(index,1)[0]);
               room.unReadMessages++;
               //room.recentMessage=data.message;
               if(data.message=="" || data.message==undefined){
                room.recentMessage=data.fileName;
              }else{
                room.recentMessage=data.message;
              }
               room.updatedOn=data.createdOn;
              } else{
               room.unReadMessages=1;
               room.recentMessage=data.message;
               room.updatedOn=data.createdOn;
              }      
             }
          }else{
            var room = this.users?.find((itm) => itm.id === data.roomId);
            if(room!=null){
              if(data.message=="" || data.message==undefined){
                room.recentMessage=data.fileName;
              }else{
                room.recentMessage=data.message;
              }
              room.updatedOn=data.createdOn;               
            }
          }
        }
       });
   
       this.newChatSubscription = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
          if(data.roomId == this.roomId && data.fromUser.email.toLowerCase()!=((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email')).toLowerCase()){
          this.GetChatMessagesListForRoom(this.roomId) 
        }           
       });
       this.newChatSubscription = this.ChatsignalRconnaction.newChatRecived.subscribe(data => {
        if(data!=null){
          this.GetChatMessagesListForRoom(this.roomId)       
        }
       });
      }

    ngOnDestroy() {
      this.clickEventsubscription.unsubscribe();
      this.clickEventsubscriptions.unsubscribe(); 
      this.newGroupCreatedSubscription.unsubscribe(); 
      this.userRemovedSubscription.unsubscribe();
      this.newChatRecivedSubscription.unsubscribe();   
    }
   loggedinEmail:any;
    ngOnInit(): void {
      this.loggedinEmail=((sessionStorage.getItem('email') == null || sessionStorage.getItem('email') == undefined) ? sessionStorage.getItem('portalemail').toLowerCase() : sessionStorage.getItem('email').toLowerCase());
  
      this.clickEventsubscription = this._dataSharingService.getDeleteChatGroup().subscribe((result) => {
        if(result){   
          this.GetAllRoomsforUser();     
          }  
       });
       this.clickEventsubscriptions = this._dataSharingService.getMessageUserOrGroup().subscribe((result) => {
        if(result){
          let index= this.users.findIndex((itm) => itm.id === result);
          this.users.unshift(this.users.splice(index,1)[0]);
          }  
       });
      this.currentDate=new Date();  
      this.GetAllRoomsforUser();       
    }


    // For Get Message 
    GetChatMessagesListForRoom(roomId) {
      var ReqModel={
        roomId: roomId,
        pageIndex: 0,
        pageSize: 500
      }  
      this.ChatsignalRconnaction.GetChatMessagesListForRoom(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.messageList = response.data.messages;          
              var groups = new Set(this.messageList.map(item => new Date(item.createdOn).toISOString().slice(0, 10)))           
              this.results = [];    
              groups.forEach(g => 
               this.results.push({
               dates: g, 
               values: this.messageList.filter(i => new Date(i.createdOn).toISOString().slice(0, 10) === g)
                }));              
               this.messageList=this.results;                
            }else{
              this.messageList=[];
            }
          } else {
            this.messageList=[];
          }
        });
    } 

    cancelUploadFile() {
      this.filepath="";
      this.fileName="";
      this.fileType="";
      if(this.message!=""){
        this.sendButtonShow = true;
      }
      else{
        this.sendButtonShow = false;
      }
    }  
  
    handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.addFileManagerFile();
    this.InputFile.nativeElement.value = '';  
    }
  
    addFileManagerFile() {
    this.dialog.closeAll();
    this.loaderService.show();
    let documentType = this.fileToUpload.name.split('.').pop();
    const formData: FormData = new FormData();
    formData.append('roomId', this.roomId);
    formData.append('name', this.fileToUpload.name);
    formData.append('file', this.fileToUpload); 
    formData.append('fileType', documentType);  
    //formData.append('officeID', this.myOfficeID);
   // formData.append("fromUserId",this.currentUser.UID) ;
    formData.append("email",((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))) ;

    this.fileName = this.fileToUpload.name;
    this.fileType = documentType;
    this.ChatsignalRconnaction.AddfileAsAttachment(formData).subscribe(response=>{
    if(response!=undefined){
       this.loaderService.hide(); 
       var responseHolder = response;
       if(responseHolder.data !="" && responseHolder.status == this.statusConst.statusSuccess) { 
          this.filepath = responseHolder.data;
          this.sendButtonShow=true;
        }else{
              this.loaderService.hide();
            }
         }else{
          this.loaderService.hide();
        }
     });
    }

    onEnter(event) {
      event.target.value = event.target.value.replace(/^\s+/, '').replace(/\s+$/, '');
      if((event.target.value!="" && event.target.value!=undefined && event.target.value!=null) || this.filepath!=""){
        this.message=event.target.value;
        this.send();
        event.preventDefault();      
      }   
    }
     emptyGuid:any = "00000000-0000-0000-0000-000000000000";
    send() {
      var ReqModel={
        roomId: this.roomId,
        message: this.message,
        fromUserId:this.emptyGuid, //this.currentUser.UID,
        messageType: 0,
        fileType: this.fileType,
        fileName: this.fileName,
        filePath: this.filepath,
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
    
      }
      this.message="";
      this.sendButtonShow=false;
      this.ChatsignalRconnaction.CreateChatMessage(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.GetChatMessagesListForRoom(this.roomId);
             this.filepath="";
             this.fileType="";
             this.fileName="";
             this.sendButtonShow=false;
             }else{      
              
             }
            } else {           
           }
         });  
    }    

    closeChat(message:boolean){
      this.searchBar();
      this.currentDate=new Date();
     // this.GetAllRoomsforUser();      
      this.hideChat.emit(message);
      this.openChatWindow.emit(message);
      this.showPanel = false;
    }

    startNewChat(templateRef: TemplateRef<any>) {
      const dialogRef = this.dialog.open(templateRef,{
        panelClass: 'custom-modalbox'
      });
      this.peoples=[];
      this.getPortalEmailUserList(this.pageModelData);
      this.DoneButtonShow=false;
    }
  
    startNewGroup(templateRef: TemplateRef<any>) {
      const dialogRef = this.dialog.open(templateRef,{
        panelClass: 'custom-modalbox'
      });
      this.peoples=[];
      this.getPortalEmailUserList(this.pageModelData);
      this.DoneButtonShow=false;
    }
    async getPortalEmailUserList(pageData: any) {
      this.pageModelData.pageIndex = pageData.pageIndex;
      this.pageModelData.pageSize = pageData.pageSize;
      this.pageModelData.SearchKey = pageData.SearchKey.trim();
      this.pageModelData.databaseID = this.databaseId==undefined? 0:Number(this.databaseId);
      this.pageModelData.organizationID =this.organizationId==undefined?0: Number(this.organizationId);
      this.pageIndex = pageData.pageIndex;
      this.pageSize = pageData.pageSize;
      if(this.pageModelData.SearchKey!=""){
      const result = await this.ChatsignalRconnaction.getPortalEmailUserList(this.pageModelData).toPromise();    
      if(result.data.userModel!=null)
      this.userListResponseHolder = result.data.userModel;
      else
      this.userListResponseHolder=[];
      if (200 === this.statusConst.statusSuccess){
        this.peoples=result.data.userModel;
           
        this.pageModelData.pageIndex = result.data.pageIndex;
        this.pageIndex = result.data.pageIndex;
        this.pageSize = pageData.pageSize;    
  
      } else {
       this.peoples=[];
      }
    }
    else{
      this.peoples=[];
     }
    }

    async getUserList(pageData: any) {
      this.pageModelData.pageIndex = pageData.pageIndex;
      this.pageModelData.pageSize = pageData.pageSize;
      this.pageModelData.SearchKey = pageData.SearchKey.trim();
      this.pageModelData.databaseID = Number(this.databaseId);
      this.pageModelData.organizationID =  Number(this.organizationId);
      this.pageIndex = pageData.pageIndex;
      this.pageSize = pageData.pageSize;
      if(this.pageModelData.SearchKey!=""){
      const result = await this.ChatsignalRconnaction.GetUsersListForChat(this.pageModelData).toPromise();    
      if(result.data.userModel!=null)
      this.userListResponseHolder = result.data.userModel;
      else
      this.userListResponseHolder=[];
      if (200 === this.statusConst.statusSuccess){
        this.userListResponseHolder.map((res) => {
          if (res.email != null) {
            res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
          }
          if (res.userName != null) {
            res.userName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.userName);
          }
          if (res.firstName != null || res.lastName != null) {
            res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.firstName);
            res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.lastName);
            res.name=res.firstName + " "+ res.lastName;
          }       
          return res;
        });
        this.peoples=result.data.userModel.filter((m) => m.uuid != this.currentUser.UID);
        this.peoples.forEach(e => {      
          e.isChecked=false
         });     
        this.pageModelData.pageIndex = result.data.pageIndex;
        this.pageIndex = result.data.pageIndex;
        this.pageSize = pageData.pageSize;    
  
      } else {
       this.peoples=[];
      }
    }
    else{
      this.peoples=[];
     }
    }  
    
    getShortName(fullName) {
      if(fullName!=undefined)
        {
      var x = fullName.split(' ').splice(0,2).join(' ');
      return x.split(' ').map(n => n[0]).join('');
        }
        return "";
    }

    getShortNameEmail(fullName) {
      var x = fullName.split('@')[0];
      return x;
    }

    SetSearchValue(val){
      if(val && val.length>2){
        this.searchValue=val;
        this.isEnabled=true;
      }
      else{
        this.peoples = [];
        this.searchValue='';
        this.isEnabled=false;
      }       
    }
    
    Search() {
        if(this.searchValue!= ''){
        this.spinner=true;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.pageModelData.SearchKey=this.searchValue.trim();    
          this.getUserList(this.pageModelData);
        }, 500);
      }else{
        this.pageModelData.SearchKey="";    
        this.getUserList(this.pageModelData);
        this.spinner=false;
      }
    } 

    SearchEmail() {
      if(this.searchValue!= ''){
      this.spinner=true;
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.pageModelData.SearchKey=this.searchValue.trim();    
        this.getPortalEmailUserList(this.pageModelData);
      }, 500);
    }else{
      this.pageModelData.SearchKey="";    
      this.getPortalEmailUserList(this.pageModelData);
      this.spinner=false;
    }
  } 

    close() {  
      this.peoples.forEach(e => {      
        e.isChecked=false
       });
      this.selectedUser=[];
      this.groupName="";
      this.pageModelData.SearchKey="";
      this.dialog.closeAll();
      this.searchValue='';
      this.isEnabled=false;
    }

    SelectUser(event,user){
      let removeIndex = this.selectedUser.findIndex((itm) => itm.email.toLowerCase() === user.email.toLowerCase());
      if (removeIndex !== -1) {
        this.selectedUser.splice(removeIndex, 1);
        this.peoples.forEach(e => {
          if(e.email.toLowerCase()==user.email.toLowerCase()) {
            e.isChecked=false;
          }
         });
       }else{
        this.peoples.forEach(e => {
          if(e.email.toLowerCase()==user.email.toLowerCase()) {
            e.isChecked=true;
          }
         });
  
         var ReqModel={
          userId: user.uuid,
          userName: this.getShortNameEmail(user.email),
          //organizationId: user.organizationId,
          profileImageUrl:null,// user.profileImagePath,
          email: user.email.toLowerCase()
         }
         this.selectedUser.push(ReqModel); 
      }
      if((this.groupName!="" && this.groupName!=undefined && this.groupName!=null)&& this.selectedUser.length > 0){
        this.DoneButtonShow=true;
      }
      else{
        this.DoneButtonShow=false;
      }      
    }

    onChange(searchValue: string) {
      if((searchValue!="" && searchValue!=undefined && searchValue!=null)&& this.selectedUser.length > 0){
        this.groupName=searchValue;
        this.DoneButtonShow=true;
      }else{
        this.DoneButtonShow=false;
      }    
    }
  
    onChangeMessage(message: string) {
      message = message.replace(/^\s+/, '').replace(/\s+$/, '');
      if((message!="" && message!=undefined && message!=null)) {
        this.message=message;
        this.sendButtonShow=true;
      }else{
        this.sendButtonShow=false;
        if(this.filepath==""){
          this.sendButtonShow=false;
        }
        else{
          this.sendButtonShow=true;
        }
      }    
    }

    CreateNewGroup() {
       var LoggedIdObj={
        userId: this.emptyGuid,//this.currentUser.UID,
        userName:this.getShortNameEmail(((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
      ), //this.currentUser.Name,
        //organizationId: this.organizationId==undefined? 0:Number(this.organizationId),
        profileImageUrl: null,
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
       }
      this.selectedUser.push(LoggedIdObj);
      var ReqModel={
        type: "Room",
        roomName: this.groupName,
        //organizationId: Number(this.organizationId),
        //createdBy: this.currentUser.UID,
        users: this.selectedUser,
        recentMessage:"",
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
      }
      this.close();
      this.ChatsignalRconnaction.CreateChatRoom(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConst.statusSuccess) {       
             this.GetAllRoomsforUser();
             this.toastr.success('Group chat created successfully.', '', {
              timeOut: 3000,
             });
            }else{
              this.close();           
            }
           } else {
            this.close();          
          }
        });
    }
    
    CreateNewChat(user) {
      var LoggedIdObj={
        userId: user.uuid,//this.currentUser.UID,
        userName:this.getShortNameEmail(((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
      ), //this.currentUser.Name,
        organizationId: this.organizationId==undefined? 0:Number(this.organizationId),
        profileImageUrl: null,
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
       }
       this.selectedUser.push(LoggedIdObj);
       var req={
        userId: user.uuid,
        userName:this.getShortNameEmail(user.email)
      ,//user.firstName +" "+ user.lastName,
        organizationId: user.organizationId,
        profileImageUrl:"", //user.profileImagePath,
        email: user.email   
       }
      this.selectedUser.push(req);
      var ReqModel={
        type: "Room",
        roomName: "",
        organizationId:this.organizationId==undefined? 0:Number(this.organizationId),
        createdBy:  user.uuid,//this.currentUser.UID,
        users: this.selectedUser,
        recentMessage:"",
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
      }
      this.close();
      this.ChatsignalRconnaction.CreateChatRoom(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConst.statusSuccess) {
             var data=this.responseHolder.data;
             if(data.users!=null){
              var checkdata=this.users.filter((itm) => itm.id === this.responseHolder.data.id);
              var firstData=checkdata[0];
              this.chatId=firstData.id;
              this.GetChatMessagesListForRoom(this.chatId);              
             }else{
              this.GetAllRoomsforUser();
              this.toastr.success('Chat created successfully.', '', {
               timeOut: 3000,
              });
             } 
            }else{
              this.close();            
            }
           } else {
            this.close();          
          }
        });
    }

    GetAllRoomsforUser() {
      var ReqModel={
        //userId:this.currentUser.UID,
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
      }
      this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConst.statusSuccess) {
           this.users=response.data;
           if(this.users.length>0){
            var firstData=this.users[0];
            this.chatId=firstData.id;
            this.roomId = this.chatId    
            this.groupname=firstData.roomName;
            this.imageUrl=firstData.imageUrl;
            this.users=response.data;
            this.GetChatMessagesListForRoom(this.chatId);         
            }
            }else{
              this.users=[];     
            }
           } else {
            this.users=[];        
          }
        });
    }
  
    GetAllRoomsforUserSearchClear() {
      var ReqModel={
        // userId:this.currentUser.UID
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
      }
      this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConst.statusSuccess) {
           this.users=response.data;        
            }else{
              this.users=[];            
            }
           } else {
            this.users=[];         
          }
        });
    }
  
    fillResult(user:any,array:any){
    if(user==undefined){
      user=[];
     }
    if(array.length>0){
     array.forEach(e => {
      user.push(e);
     });
    }
    return user;
    }
    
    SearchChatOrMessages() {
      if(this.searchTerm != ''){
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.findChatOrMessages();
      }, 600);
      }else{
      this.findChatOrMessages();
      }
    } 
    
    findChatOrMessages() {
      if(this.searchTerm.replace(/\s/g, "").toLowerCase()=="") {  
        this.GetAllRoomsforUserSearchClear();
        return;
      }
      var ReqModel={
        searchTerm:this.searchTerm,
        userId: this.currentUser.UID,
        email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email')),
        pageIndex: 0,
        pageSize: 0     
      }   
      this.ChatsignalRconnaction.SearchChatOrMessages(ReqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConst.statusSuccess) {
           this.users=[];  
           this.users=this.fillResult(this.users,response.data.chatMessages);
           this.users=this.fillResult(this.users,response.data.chatRoomsWithMatchNames);
           this.users=this.fillResult(this.users,response.data.chatRoomsWithMatchedUser);       
           this.users= this.users.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i);  
            }else{
              this.users=[];;
            }
           } else {
            this.users=[];
          }
        });
    }

    chatDetails(users){
      users.unReadMessages=0;
      this.chatId=users.id;
      this.messageList=[];
      this.participantDetails=users;                  
      this.roomId=this.participantDetails.id;
      this.groupname=this.participantDetails.roomName;
      this.imageUrl=this.participantDetails.imageUrl;
      this.message="";
      this.sendButtonShow=false;
      this.GetChatMessagesListForRoom(this.chatId);   
      this.showPanel = true;
      this.showSearch =false;
      this.openChatWindow.emit(true);      
    }
    
    openPanel(message:boolean){
      this.showPanel = true;
      this.openChatWindow.emit(message);       
    }    

    searchBar(){
      this.showSearch = !this.showSearch;
    }

    addFolder(templateRef: TemplateRef<any>) {
      const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'custom-modalbox'
      });   
    }

    openDocumentViewer(message: boolean,document,templateRef: TemplateRef<any>) {  
      this._dataSharingService.sendSelectedDocumentForChat(document);
      this.documentViewer.emit(message);
      this.dialog.open(templateRef);
    }

    getCloseDocumentViewer(message: boolean) {
      this.documentViewer.emit(false);
      this.dialog.closeAll();
    }
    
}
